<div class="menu-filter">
  <button
    [matMenuTriggerFor]="filterMenuOptionList"
    class="btn-phantom-alt hover:shadow-lg"
  >
    <ui-icon name="filter" fill="neutrals-600" m-size="24" size="24" />
    Filtrar
  </button>
  <mat-menu #filterMenuOptionList="matMenu" class="bg-white">
    <div
      class="grid grid-flow-row gap-2 py-4 w-[256px]"
      (click)="$event.stopImmediatePropagation()"
    >
      <p class="px-4">Por asignación</p>
      <mat-radio-group
        class="flex flex-col px-2 filter-response-type"
        [value]="selected"
        [disabled]="loading"
        (change)="changeFilter($event.value)"
      >
        <mat-radio-button [value]="FILTER_VALUES.ASSIGNED_TO_ALL">
          <ui-paragraph
            type="p12"
            [attr.text-color]="
              selected === FILTER_VALUES.ASSIGNED_TO_ALL
                ? 'neutrals-900'
                : 'neutrals-700'
            "
          >
            Asignados a todos
          </ui-paragraph>
        </mat-radio-button>

        <mat-radio-button [value]="FILTER_VALUES.ASSIGNED_TO_ME">
          <ui-paragraph
            type="p12"
            [attr.text-color]="
              selected === FILTER_VALUES.ASSIGNED_TO_ME
                ? 'neutrals-900'
                : 'neutrals-700'
            "
          >
            Asignados a mi
          </ui-paragraph>
        </mat-radio-button>
      </mat-radio-group>

      <p class="px-4 mt-4">Por tipo de respuesta</p>
      <mat-radio-group
        class="flex flex-col px-2 filter-response-type"
        [value]="selectedResponseType"
        [disabled]="loading"
        (change)="changeResponseFilter($event.value)"
      >
        <mat-radio-button [value]="RESPONSE_FILTER_VALUES.ALL">
          <ui-paragraph
            type="p12"
            [attr.text-color]="
              selectedResponseType === RESPONSE_FILTER_VALUES.ALL
                ? 'neutrals-900'
                : 'neutrals-700'
            "
          >
            Todos
          </ui-paragraph>
        </mat-radio-button>

        <mat-radio-button [value]="RESPONSE_FILTER_VALUES.UNANSWERED">
          <ui-paragraph
            type="p12"
            [attr.text-color]="
              selectedResponseType === RESPONSE_FILTER_VALUES.UNANSWERED
                ? 'neutrals-900'
                : 'neutrals-700'
            "
          >
            Sin responder
          </ui-paragraph>
        </mat-radio-button>

        <mat-radio-button [value]="RESPONSE_FILTER_VALUES.ANSWERED">
          <ui-paragraph
            type="p12"
            [attr.text-color]="
              selectedResponseType === RESPONSE_FILTER_VALUES.ANSWERED
                ? 'neutrals-900'
                : 'neutrals-700'
            "
          >
            Respondido
          </ui-paragraph>
        </mat-radio-button>
      </mat-radio-group>

      <p class="px-4 mt-4">Tipo de producto</p>
      <div class="flex flex-col px-2">
        <mat-checkbox
          *ngFor="let business of businessUnit"
          class="unicon-checkbox"
          [checked]="isBusinessLineSelected(business.name)"
          [disabled]="loading || isLastBusinessLineSelected(business.name)"
          (change)="onBusinessLineToggle(business.name, $event.checked)"
        >
          <ui-paragraph
            type="p12"
            [attr.text-color]="
              isBusinessLineSelected(business.name)
                ? 'neutrals-900'
                : 'neutrals-700'
            "
          >
            {{ business.name }}
          </ui-paragraph>
        </mat-checkbox>
      </div>
    </div>
  </mat-menu>
</div>
